import React from 'react';
import Modal from './Modal';
import BottomSheet from './BottomSheet';
import useMediaQuery from 'hooks/useMediaQuery';
import breakpoints from 'theme/breakpoints';

const SIZE_MAP = { small: 'medium', default: 'medium', large: 'large' };

export default function ResponsiveModal({ isOpen, onClose, title, size = 'default', children }) {
    const isDesktop = useMediaQuery(`(min-width: ${breakpoints.lg})`);

    if (isDesktop) {
        return (
            <Modal isOpen={isOpen} onClose={onClose} title={title} size={SIZE_MAP[size] || 'medium'} childrenOverflowY='scroll'>
                {children}
            </Modal>
        );
    }

    return (
        <BottomSheet isOpen={isOpen} onClose={onClose} title={title} size={size}>
            {children}
        </BottomSheet>
    );
}
